// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs_breadcrumbs__K4VlV","link":"breadcrumbs_link__ejFV2 button_linkReset__tYXIA"};